import { render, staticRenderFns } from "./RegisterDuplicateRegistration.vue?vue&type=template&id=e5373a7e&scoped=true&"
import script from "./RegisterDuplicateRegistration.vue?vue&type=script&lang=js&"
export * from "./RegisterDuplicateRegistration.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDuplicateRegistration.vue?vue&type=style&index=0&id=e5373a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5373a7e",
  null
  
)

export default component.exports